import apiClient from '@/plugins/apiClient'
const env = import.meta.env
let basePath = "/settings/"+env.VITE_APP_DOMAIN;

export default {
    namespaced: true,
    state:{
         hasSettings: (sessionStorage.getItem('hasSettings') === 'true'),
         footer: sessionStorage.getItem('footer'),
         primary: sessionStorage.getItem('primary'),
         social: sessionStorage.getItem('social'),
         cookie: sessionStorage.getItem('cookie'),
    },
    getters:{
        hasSettings: state => state.hasSettings,
        footer: state => (state.footer) ? JSON.parse(state.footer) : null,
        primary: state => (state.primary) ? JSON.parse(state.primary) : null,
        social: state => (state.social) ? JSON.parse(state.social) : null,
        cookie: state => (state.cookie) ? JSON.parse(state.cookie) : null,
    },
    mutations:{
        setFull(state, resp) {
            console.log('setFullSetting',resp)
            
            resp.data.forEach((element) => {
                state[element.slug] = JSON.stringify(element)
                sessionStorage.setItem(element.slug, JSON.stringify(element));
            });
            state.hasSettings = true;
            sessionStorage.setItem('hasSettings',true);
            console.log('setFullSetting', state);

        },
        error(state, err) {
           state.hasSettings = false;
           console.error('error', err);
        }
    },
    actions:{
        getSettings({commit}, data){
            return new Promise((resolve, reject) => {
                 console.log('GET LIST :'+data)
                 apiClient.get(basePath).then(resp => {
                      commit('setFull', resp.data);
                      resolve(resp);
                  })
                  .catch(err => {
                      console.log('GET SINGLE', err)
                      commit('error', err);
                      reject(err);
                  });
            })
       },
    }
}